import React, { useMemo } from "react";
import { formatCurrency } from "../../../../utils/SamuiUtils";

export default React.memo(function DataTable({
  fields,
  data,
  onSort,
  sortField,
  sortOrder,
  onRowClick,
  sums,
}) {


  return (
    <div className="card p-2">
      <div
        className="table-responsive"
        style={{ height: "70vh", overflowY: "auto" }}
      >
        <table className="table table-striped table-hover">
          <thead className="thead-dark">
            <tr>
              {fields.map((f) => (
                <th
                  key={f.key}
                  style={{
                    width: f.w,
                    cursor: f.sortable ? "pointer" : "default",
                  }}
                  className={`text-${f.alignHeader} text-nowrap`}
                  onClick={() => f.sortable && onSort(f.key)}
                >
                  {f.label}
                  {f.sortable && (
                    <span className="ms-1">
                      {f.key === sortField ? (
                        sortOrder === "asc" ? (
                          <i className="fas fa-sort-up text-white"></i>
                        ) : (
                          <i className="fas fa-sort-down text-white"></i>
                        )
                      ) : (
                        <i className="fas fa-sort text-muted" style={{ opacity: 0.5 }}></i>
                      )}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map((item, i) => (
                <tr
                  key={i}
                  style={{ cursor: "pointer" }}
                  onClick={() => onRowClick(i)}
                >                  {fields.map((f, j) => {
                    let value;
                    
                    // Handle specific fields with custom formatting
                    if (f.key === "TotalQty") {
                      value = Math.round(item.TotalQty || 0).toLocaleString();
                    } else if (f.key === "total_supplier") {
                      value = `${item.total_supplier || 0}`;
                    } else if (f.key === "total_supplier_repeat") {
                      value = `${item.total_supplier_repeat || 0}`;
                    } else if (f.key === "purchaseCount") {
                      value = `${item.purchaseCount || 0}`;
                    } else if (f.key === "repeat_rate") {
                      value = `${item.repeat_rate || 0}%`;
                    } else if (f.key === "Item_Total") {
                      value = formatCurrency(item.Item_Total || 0);
                    } else if (f.numeric) {
                      value = formatCurrency(item[f.key] || 0);
                    } else {
                      value = item[f.key] || "";
                    }
                    
                    return (
                      <td key={j} className={`text-${f.align}`}>
                        {value}
                      </td>
                    );
                  })}
                </tr>
              ))            ) : (
              <tr>
                <td colSpan={fields.length}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>          <tfoot>
            <tr>
              <th colSpan={5} className="text-end">
                รวมทั้งหมด {data.length} รายการ
              </th>
              <th className="text-end">
                {formatCurrency(
                  data.reduce((s, d) => s + (d.Item_Total || 0), 0)
                )}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});